import React, { Component } from 'react';
import { PropTypes } from "prop-types";
import { Dialog, FlatButton, RaisedButton, AutoComplete } from 'material-ui'
import { restApi } from '../config';

const styles = {
  dialogContent: {
    padding: '20px 0'
  },
  roleLabel: {
    marginRight: '10px'
  },
  autoComplete: {
    display: 'inline-block',
    width: '200px'
  }
};

export default class AdminUserFilter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedRole: '',
      availableRoles: [],
      roleNames: []
    };

    this.loadRoles = this.loadRoles.bind(this);
  }

  handleOpen = () => {
    this.setState({open: true});
    this.loadRoles();
  };

  handleClose = () => {
    this.setState({
      open: false,
      selectedRole: ''
    });
  };

  loadRoles() {
    restApi.get('/users/roles').then(({data}) => {
      const roles = Object.keys(data);
      const roleNames = roles.map(role => ({
        text: data[role].name || role,
        value: role,
        searchText: `${data[role].name || role} ${role}`.toLowerCase()
      }));
      this.setState({
        availableRoles: data,
        roleNames: roleNames
      });
    }).catch((error) => {
      console.error("Unable to get roles: " + error);
    });
  }

  customRoleFilter = (searchText, key, item) => {
    if (!searchText) {
      return true;
    }
    
    const searchLower = searchText.toLowerCase();
    
    return item.searchText.includes(searchLower);
  };

  handleRoleChange = (searchText, dataSource, params) => {
    this.setState({ selectedRole: searchText });
  };

  handleFilter = () => {
    if (this.state.selectedRole) {
      // Find the actual role key from the display name
      const roleEntry = this.state.roleNames.find(role => 
        role.text === this.state.selectedRole
      );
      
      if (roleEntry) {
        this.props.onFilter(roleEntry.value);
      } else {
        // If no exact match found, try to find by partial match in case user typed manually
        const partialMatch = this.state.roleNames.find(role =>
          role.text.toLowerCase().includes(this.state.selectedRole.toLowerCase()) ||
          role.value.toLowerCase().includes(this.state.selectedRole.toLowerCase())
        );
        
        if (partialMatch) {
          this.props.onFilter(partialMatch.value);
        } else {
          // or use the text as entered
          this.props.onFilter(this.state.selectedRole);
        }
      }
    }
    this.handleClose();
  };

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Filter"
        primary={true}
        disabled={!this.state.selectedRole}
        onClick={this.handleFilter}
      />,
    ];

    return (
      <div>
        <RaisedButton 
          label="Filter Users" 
          primary={true} 
          onClick={this.handleOpen} 
          style={this.props.style}
        />
        <Dialog
          title="Filter Users"
          actions={actions}
          modal={true}
          open={this.state.open}
        >
          <div style={styles.dialogContent}>
            <span style={styles.roleLabel}>Filter user by role:</span>
            <AutoComplete
              hintText="Start typing a role..."
              searchText={this.state.selectedRole}
              onUpdateInput={this.handleRoleChange}
              dataSource={this.state.roleNames}
              dataSourceConfig={{ text: 'text', value: 'text' }}
              filter={this.customRoleFilter}
              maxSearchResults={10}
              openOnFocus={true}
              style={styles.autoComplete}
            />
          </div>
        </Dialog>
      </div>
    );
  }
}

AdminUserFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
};